export const RepositioningOptions = [
  "Sat up in bed",
  "Sat up with knee break",
  "Sat out",
  "Flat on back",
  "Prone",
  "Right side",
  "Left side",
  "Right side tilt",
  "Left side tilt",
  "Supine",
  "Fowler's Position",
  "Semi-Fowler's Position",
  "High Fowler's Position",
  "Sim's Position",
  "Orthopneic Position",
  "Trendelenburg",
  "Reverse Trendelenburg",
];